const SettlementStatus = {
  ForSettlement: "for-settlement",
  ForProcessing: "for-processing",
  Processed: "processed",
  Cancelled: "cancelled",
};

export default SettlementStatus;
